export type ListPhase = "collapsed" | "skeleton" | "rows" | "empty";

type NextListPhaseArgs = {
  lastPhase: ListPhase;
  hasRows: boolean;
  isWaitingForRows: boolean;
  isEmpty: boolean;
  isSlowLoad: boolean;
  isSettledEmpty: boolean;
};

export const nextListPhase = ({
  lastPhase,
  hasRows,
  isWaitingForRows,
  isEmpty,
  isSlowLoad,
  isSettledEmpty,
}: NextListPhaseArgs): ListPhase => {
  if (hasRows) {
    return "rows";
  }
  if (isWaitingForRows) {
    // An open list holds its place with the skeleton while a refined query loads, instead of collapsing.
    return isSlowLoad || lastPhase !== "collapsed" ? "skeleton" : "collapsed";
  }
  if (isEmpty) {
    if (isSettledEmpty || lastPhase === "rows" || lastPhase === "empty") {
      return "empty";
    }
    // A finished load can land a render before its rows, so the skeleton waits instead of flashing "No results".
    if (lastPhase === "skeleton") {
      return "skeleton";
    }
  }
  return "collapsed";
};

// Only a load's outcome animates in; whatever a keystroke produces snaps.
export const isLoadArrival = ({
  phase,
  lastPhase,
  isLoadPending,
}: {
  phase: ListPhase;
  lastPhase: ListPhase;
  isLoadPending: boolean;
}) =>
  phase !== lastPhase &&
  ((phase === "rows" && (lastPhase === "skeleton" || isLoadPending)) ||
    (phase === "empty" && lastPhase === "skeleton"));
